<script lang="ts">
	import type { Snippet } from 'svelte'
	import { requireI18n } from '$i18n/i18n'
	/**
	 * kit-route globals. tokens + main/global live here — sole owner.
	 * Do not re-import in App.svelte.
	 */
	import '$styles/tokens/colors.css'
	import '$styles/main.scss'
	import '$styles/global.scss'

	let { children }: { children: Snippet } = $props()

	// ports the pre-kit src/main.ts boot: optional MSW worker (dev-only),
	// then the i18n gate — the app never renders without translations
	async function boot() {
		if (import.meta.env.DEV && import.meta.env.VITE_USE_MSW === 'true') {
			const { setupWorker } = await import('msw/browser')
			const { handlers } = await import('$mocks/handlers/dev')
			await setupWorker(...handlers).start({ onUnhandledRequest: 'bypass' })
		}
		// requireI18n, not bare loadTranslation: skips the fetch when another
		// entry already loaded translations (same boot contract as pre-kit main.ts)
		await requireI18n(() => {})
	}
</script>

{#await boot()}
	<!-- intentionally blank: pre-kit behavior, nothing mounts before i18n resolves -->
{:then}
	{@render children()}
{:catch error}
	<!-- raw string: i18n itself failed to load, $t() has nothing to offer -->
	<p role="alert" data-testid="boot-error" style="padding: 2rem; font-family: sans-serif">
		Die Anwendung konnte nicht geladen werden. Bitte Seite neu laden. ({String(error)})
	</p>
{/await}
